import { render, staticRenderFns } from "./InventoryAmount.vue?vue&type=template&id=0d7ef063&scoped=true&"
import script from "./InventoryAmount.vue?vue&type=script&lang=js&"
export * from "./InventoryAmount.vue?vue&type=script&lang=js&"
import style0 from "./InventoryAmount.vue?vue&type=style&index=0&id=0d7ef063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7ef063",
  null
  
)

export default component.exports